module.exports = __webpack_public_path__ + "img/kids.e0f5cd39.svg";